<template>
  <eg-modal
    id="confirmation-leave-modal"
    :title="title || $t('dashboard.confirmation.leaveTitle')"
    size="md"
    centered
    z-index="1057"
    @close="onHidden"
  >
    <div class="confirmation-leave-modal-content">
      <eg-icon class="mr-3" icon="risk-warning-error-danger"> </eg-icon>

      <span class="confirmation-leave-modal-content-text">
        {{ text || $t("dashboard.confirmation.leaveText") }}
      </span>
    </div>

    <template #modal-footer="{ close }">
      <div class="d-flex align-items-center justify-content-end">
        <eg-button type="secondary" @click="confirmationLeaveAction">
          {{ $t("dashboard.confirmation.leaveContinue") }}
        </eg-button>

        <eg-button class="ml-2" type="primary" @click="close">
          {{ okTitle || $t("dashboard.confirmation.leaveStay") }}
        </eg-button>
      </div>
    </template>
  </eg-modal>
</template>

<script>
import EgButton from "@/components/global/eg/buttons/eg_button.vue";
import EgIcon from "@/components/global/eg/eg_icon.vue";

export default {
  name: "ConfirmationLeaveModal",
  components: {
    EgButton,
    EgIcon,
  },

  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    okTitle: {
      type: String,
      default: "",
    },
    resolve: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      isConfirmed: false,
    };
  },

  methods: {
    onHidden() {
      if (!this.isConfirmed) {
        this.resolve && this.resolve(false);
      }
    },

    async confirmationLeaveAction() {
      this.isConfirmed = true;
      this.resolve && this.resolve(true);
      this.$egModal.hide("confirmation-leave-modal");
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmation-leave-modal-content {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-surface-semantic-error-light);
  padding: 20px 24px;
  border-radius: var(--radius-rd-400);

  .confirmation-leave-modal-content-text {
    color: var(--colors-red-500);
  }

  .eg-icon {
    color: var(--colors-red-500) !important;
  }
}

.confirm-text-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

#confirmation-leave-modal::v-deep {
  .eg-modal__body {
    padding: 24px !important;
  }
}
</style>
